import React from 'react';
import '../styles/HomePage.css';

function TermsPage(){

  return(

    <div className="homepage-container">

      <section className="workforce-hero fade-in">

        <div className="hero-content">

          <p className="eyebrow">
            AXU Workforce
          </p>

          <h1>
            Terms & Conditions
          </h1>

          <p>
            Please read these terms carefully before using the AXU Workforce
            website or submitting an application or staffing request.
          </p>

        </div>

      </section>

      <section className="content-section fade-in">

        <div className="feature-card">

          <h3>Use of Our Website</h3>

          <p>
            By accessing this website you agree to use it lawfully and
            responsibly. You must not misuse the website or attempt to gain
            unauthorised access to any part of our systems.
          </p>

        </div>

      </section>

      <section className="content-section fade-in">

        <div className="feature-card">

          <h3>Worker Applications</h3>

          <ul>

            <li>Submitting an application does not guarantee employment.</li>

            <li>Applicants must provide accurate information.</li>

            <li>Applicants may be asked to provide proof of identity and Right to Work.</li>

            <li>Applications may be declined if information is inaccurate or incomplete.</li>

          </ul>

        </div>

      </section>

      <section className="content-section fade-in">

        <div className="feature-card">

          <h3>Employer Requests</h3>

          <ul>

            <li>Employers are responsible for providing accurate job information.</li>

            <li>Worker availability cannot be guaranteed.</li>

            <li>Staffing requests are subject to worker availability and suitability.</li>

          </ul>

        </div>

      </section>

      <section className="content-section fade-in">

        <div className="feature-card">

          <h3>Limitation of Liability</h3>

          <p>
            AXU Workforce is not responsible for losses arising from inaccurate
            information submitted by users or circumstances outside our reasonable
            control.
          </p>

        </div>

      </section>

      <section className="content-section fade-in">

        <div className="feature-card">

          <h3>Changes to These Terms</h3>

          <p>
            We may update these Terms & Conditions from time to time.
            Continued use of this website constitutes acceptance of the
            latest version.
          </p>

        </div>

      </section>

      <section className="content-section fade-in">

        <div className="feature-card">

          <h3>Contact</h3>

          <p>
            If you have any questions regarding these Terms & Conditions,
            please contact:
          </p>

          <p>
            info@axuworkforce.co.uk
          </p>

        </div>

      </section>

    </div>

  );

}

export default TermsPage;